import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { supabase } from './supabaseClient';
import SupasoLogoSpinner from './SupasoLogoSpinner';
import './LoginHub.css';

const LoginHub = ({ onLoginSuccess }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showEmail, setShowEmail] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const { data, error: authError } = await supabase.auth.signInWithPassword({
                email: email.trim().toLowerCase(),
                password: password.trim()
            });

            if (authError) throw authError;

            const { data: adminData, error: adminError } = await supabase
                .from('usuarios_admin')
                .select('*')
                .eq('correo', email.trim().toLowerCase())
                .single();

            if (adminError || !adminData) {
                await supabase.auth.signOut();
                throw new Error('No tienes perfil de administrador habilitado.');
            }

            const rol = (adminData.rol || '').toLowerCase();
            if (rol !== 'superadmin' && rol !== 'admin') {
                await supabase.auth.signOut();
                throw new Error('Permisos insuficientes para el HUB.');
            }

            onLoginSuccess(adminData);
        } catch (err) {
            setError(err.message === 'Invalid login credentials' ? 'Credenciales incorrectas.' : err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-hub-container">
            <motion.div 
                className="login-hub-card"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <div className="login-logo-box">
                    <SupasoLogoSpinner size="normal" />
                </div>
                
                <h2 className="login-hub-title">Acceso Restringido</h2>
                <p className="login-hub-subtitle">Portal de Administración Centralizada</p>

                {error && (
                    <motion.div 
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        className="hub-login-error"
                    >
                        {error}
                    </motion.div>
                )}

                <form onSubmit={handleLogin} className="login-hub-form">
                    <div className="hub-form-group">
                        <label>EMAIL</label>
                        <div className="input-with-icon">
                            <input 
                                type={showEmail ? "text" : "password"} 
                                className="hub-form-input" 
                                placeholder="usuario@supaso.org"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <button 
                                type="button" 
                                className="toggle-eye" 
                                onClick={() => setShowEmail(!showEmail)}
                                tabIndex="-1"
                            >
                                <span className="material-icons-round">
                                    {showEmail ? 'visibility_off' : 'visibility'}
                                </span>
                            </button>
                        </div>
                    </div>

                    <div className="hub-form-group">
                        <label>CONTRASEÑA</label>
                        <div className="input-with-icon">
                            <input 
                                type={showPassword ? "text" : "password"} 
                                className="hub-form-input" 
                                placeholder="••••••••"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <button 
                                type="button" 
                                className="toggle-eye" 
                                onClick={() => setShowPassword(!showPassword)}
                                tabIndex="-1"
                            >
                                <span className="material-icons-round">
                                    {showPassword ? 'visibility_off' : 'visibility'}
                                </span>
                            </button>
                        </div>
                    </div>

                    <button type="submit" className="hub-btn-login" disabled={loading}>
                        {loading ? 'Verificando...' : 'Ingresar al Panel'}
                    </button>
                </form>

                <div className="hub-login-footer">
                    <div className="hub-version-tag">
                        © 2026 - <span style={{ color: '#0086CE' }}>SUPASO</span> Tecnología - <b>v1.1</b>
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

export default LoginHub;
